import template from "./entity-reporting.html";
import "./entity-reporting.less";
import swal from "sweetalert2";

import { FORM_ENTITY_NUMBERS } from "../../../../../../routes";

export function controller(appState, api, toastr, loadingService, $uibModal, $logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		const nomenclature = appState.forms.selected.nomenclature;
		ctrl.positiveNomenclature = nomenclature.PositiveReport;

		loadNextReportNumber();
	};

	function loadNextReportNumber() {
		const route = FORM_ENTITY_NUMBERS(appState.forms.selected.Id, ctrl.entity.Id);
		
		const promise = api.get(route)
			.then(nextNumber => {
				ctrl.nextNumber = nextNumber.Next;
				if(nextNumber.etag) {
					ctrl.etag = nextNumber.etag; 
				}

				return;
			});

		loadingService.watch(promise);
	}

	function setNextReportNumber(number) {
		const route = FORM_ENTITY_NUMBERS(appState.forms.selected.Id, ctrl.entity.Id);
		const payload = {
			NextNumber: number,
			ifMatch: ctrl.etag
		};
		
		const promise = ctrl.put(route, payload)
			.then((success) => {
				ctrl.nextNumber = success.Next;
				ctrl.etag = success.etag;

				toastr.success(`Successfully updated next report number to be ${number}.`);

				return;
			});

		loadingService.watch(promise);
	}

	ctrl.editNextNumber = () => {
		const instance = $uibModal.open({
			component: "edit-report-number-modal",
			size: "sm",
			backdrop: "static",
			resolve: {
				number: () => ctrl.nextNumber
			}
		});

		instance.result
			.then(updated => {
				if(updated < ctrl.nextNumber) {
					return showLessThanCurrentWarning()
						.then(proceed => {
							if(proceed.dismiss) {
								return; 
							}

							setNextReportNumber(updated);
						});
				}

				setNextReportNumber(updated);
			});
	};

	function showLessThanCurrentWarning() {
		return swal.fire({
			title: "Warning!",
			html:
				`You are attempting to set the next report number to be less than the current next number.
					<br/>
					<br/>
					This may result in conflicts with existing reports.
					<br/>
					<br/>
					Are you sure you want to do that?`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Yes, do it!",
			focusCancel: true,
			reverseButtons: true
		})
			.catch(err => {
				this.$logger.error(err);

				throw err;
			});
	}
}

export default angular.module("vesl.components.entity-reporting", [])
	.component("entityReporting", {
		controller,
		template,
		bindings: {
			entity: "<",
			readonly: "<",
			put: "=",
			post: "="
		}
	})
	.name;
